import { createSelector } from '@ngrx/store';
import { PointsTransferMembership } from '@rd/types';
import {
  getSingleLoyaltyProgram,
  getSingleLoyaltyProgramLoading,
} from './loyalty-program.selectors';
import {
  getMembershipLoading,
  getMembershipMemberships,
  getMembershipsIsLoaded,
} from './membership.selectors';

// To access, this.store.get(getLoyaltyProgramMembership, { id: loyaltyProgramId })
export const getLoyaltyProgramMembership = createSelector(
  getMembershipMemberships,
  getSingleLoyaltyProgram,
  (memberships, loyaltyProgram): PointsTransferMembership | null => {
    if (!loyaltyProgram?.id) {
      return null;
    }
    const { id } = loyaltyProgram;

    const foundMembership = Object.values(memberships).find(
      (membership) => membership.loyaltyProgramId === id,
    );

    return (foundMembership as PointsTransferMembership) ?? null;
  },
);

export const getSingleLoyaltyProgramOrMembershipsAreLoading = createSelector(
  getSingleLoyaltyProgramLoading,
  getMembershipLoading,
  getMembershipsIsLoaded,
  (loyaltyProgramIsLoading, membershipsAreLoading, membershipsHaveLoaded) => {
    return (
      loyaltyProgramIsLoading ||
      (!membershipsHaveLoaded && membershipsAreLoading)
    );
  },
);
